export namespace DisplaysteuerungConfigTypes {
    export const DISPLAYSTEUERUNG_MANDANT_OPTIONS = 'displaysteuerung';
    
}

